'use client';

import { ChangeEvent, FunctionComponent, useState } from 'react';
import { Button, ButtonSize, ButtonType } from '@nx-frontend/shared/ui/button';
import { UiInput, UiInputView } from '@nx-frontend/shared/ui/input';

export const ModalLogin: FunctionComponent = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setEmail(newValue);
  };

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setPassword(newValue);
  };

  return (
    <div>
      <p className="font-xs text-gray-400">Subtitle text</p>
      <p className="font-sm text-center w-[270px] px-3 py-5 ">
        Greyhound divisively hello coldly wonderfuly marginally far upon excluding.
      </p>
      <UiInput
        id="email"
        type="text"
        label="Lable"
        value={email}
        name="email"
        placeholder="Placeholder"
        error={false}
        view={UiInputView.LABEL_TOP}
        onChange={handleEmailChange}
      />
      <UiInput
        id="password"
        type="password"
        label="Lable"
        value={password}
        name="password"
        placeholder="Placeholder"
        error={false}
        view={UiInputView.LABEL_TOP}
        onChange={handlePasswordChange}
      />
      <p className="font-sm text-center w-[270px] px-3 pb-5 ">
        Greyhound divisively hello coldly wonderfuly marginally far upon excluding.
      </p>
      <div className="flex gap-4 items-center justify-center p-4">
        <Button type={ButtonType.STROKED} size={ButtonSize.MD} onClick={() => alert('Action 1')}>
          Action 1
        </Button>
        <Button type={ButtonType.FLAT} size={ButtonSize.MD} onClick={() => alert('Action 2')}>
          Action 2
        </Button>
      </div>
    </div>
  );
};
